@let texts = resourcesService.languageFile.value();
<div class="answer-inner-container">
  <h2 class="answer-header" [class.inside-panel]="insidePanel()">
    {{ texts.correctAnswerIs }} {{ store.answer() }}
  </h2>
  <div class="answer-content">
    <div class="answer-description">
      @for (paragraph of store.currentQuestion()?.answerDescription; track paragraph) {
        <div>{{ paragraph }}</div>
      }
    </div>
  </div>
  <div class="show-map-button-container">
    <p-button
      (onClick)="toggleAnswerOnMap()"
      [text]="true"
      styleClass="show-map-button"
    >
      <img
        class="show-map-button-icon"
        src="assets/icons/Kaart.svg"
        alt=""
        aria-hidden="true"
      />
      {{ store.isShowingAnswerOnMap() ? texts.hideMap : texts.showOnMap }}
    </p-button>
  </div>
</div>
